import { GridColDef } from "@mui/x-data-grid";
import { useTranslate } from "src/locales";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";

//MUZUN;454081;07042025
export interface DocumentsData {
  id: number;
  folderName: string;
  addedDate: string;
}

export const initialDocumentsData: DocumentsData[] = [
  {
    id: 1,
    folderName: "Dosya Yolu",
    addedDate: "08.01.2026",
  },
];

export const useDocumentsColumns = (): GridColDef[] => {
  const { t } = useTranslate();

  return [
    {
      field: "open",
      headerName: t("buttons.open"),
      width: 100,
      renderCell: (params) => (
        <ByzMuiButton
          variant2="contained"
          color="primary"
          onClick={() => console.log(`Döküman Açılıyor: ${params.row.documentsName}`)}
        >
          {t("buttons.open")}
        </ByzMuiButton>
      ),
    },
    {
      field: "addedDate",
      headerName: t("adverse-effect-form.added-date"),
      width: 150,
    },
    {
      field: "folderName",
      headerName: t("adverse-effect-form.file-name"),
      flex: 1,
    },
    {
      field: "edit",
      headerName:  t("adverse-effect-form.edit"),
      renderCell: (params) => (
        <ByzGrdEditButton
          onClick={() => console.log(`Düzenleniyor: ${params.row.documentsName}`)}
        />
      ),
    },
    {
      field: "delete",
      headerName: t("adverse-effect-form.delete"),
      renderCell: (params) => (
        <ByzGrdDeleteButton
          onClick={() => console.log(`Siliniyor: ${params.row.documentsName}`)}
        />
      ),
    },
  ];
};
